import React from 'react';
const SystemTaskSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-system-task" });
SystemTaskSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-system-task sirius-icon-system-task-enhance" });
export default SystemTaskSvg;
